import { useState } from "react";
import { MessageCircle, Copy, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { Btn, Card, inputCls } from "./ui";

export default function MessageCard({ m, warning }) {
  const [text, setText] = useState(m.testo);
  const waUrl = `${m.wa_url.split("?text=")[0]}?text=${encodeURIComponent(text)}`;
  const copy = async () => { try { await navigator.clipboard.writeText(text); toast.success("Messaggio copiato"); } catch { toast.error("Copia non riuscita"); } };
  return (
    <Card className="p-4" data-testid={`msg-${m.key}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs uppercase tracking-[0.15em] text-[#9A948A]">{m.titolo}</p>
        {text !== m.testo && <button onClick={() => setText(m.testo)} className="flex items-center gap-1 text-xs text-[#9A948A] hover:text-white" data-testid={`msg-${m.key}-reset`}><RotateCcw size={12} /> Ripristina</button>}
      </div>
      <textarea className={`${inputCls} mt-2 min-h-[120px] text-sm leading-relaxed`} value={text} onChange={(e) => setText(e.target.value)} data-testid={`msg-${m.key}-text`} />
      <p className="mt-1 text-[0.7rem] text-[#6F6A62]">Puoi modificare il testo prima di inviarlo. Le modifiche valgono solo per questo invio.</p>
      {warning}
      <div className="mt-3 flex gap-2">
        <a href={waUrl} target="_blank" rel="noreferrer" data-testid={`msg-${m.key}-wa`}><Btn variant="wa" className="px-4 py-2 text-xs"><MessageCircle size={14} /> Invia su WhatsApp</Btn></a>
        <Btn variant="dark" className="px-4 py-2 text-xs" onClick={copy} data-testid={`msg-${m.key}-copy`}><Copy size={14} /> Copia</Btn>
      </div>
    </Card>
  );
}
